import axios from "axios";
import globals from "../globlas";
import storageLocal from "./storageLocal";

const APIBASE = globals.REACT_APP_URL_BASE_API;

const ENDERECO = globals.REACT_APP_ENDERECO;

function getToken() {
  return storageLocal.get("tokenLogin")?.token;
}

// Criação da instância do axios
const axiosInstance = axios.create({
  baseURL: APIBASE,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptores de requisição
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Função para lidar com erros
function handleError(error) {
  const { response } = error;
  if (response) {
    const { status, data } = response;

    if (status >= 400 && status < 500) {
      // Erros do lado do cliente
    } else if (status >= 500) {
      // Erros do lado do servidor
    }
  } else {
    // Erro sem resposta do servidor (exemplo: falha de conexão)
  }
  return Promise.reject(error);
}

// Interceptores de resposta
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config.url.includes("catalogo/saldo")) {
      return Promise.reject(error);
    }
    return handleError(error);
  }
);

// Definição dos métodos da API
const ApiServicesLogin = {
  apiLogin: (url, obj) => axiosInstance.post(url, obj),
  apiGet: (url) => axiosInstance.get(url).then((res) => res.data),
  apiPost: (url, obj) => axiosInstance.post(url, obj).then((res) => res.data),
  apiPostCatalogo: (url, obj) => axiosInstance.post(url, obj),
  apiPut: (url, obj) => axiosInstance.put(url, obj).then((res) => res.data),
  apiPatch: (url, obj) => axiosInstance.patch(url, obj).then((res) => res.data),
  apiDel: (url) => axiosInstance.delete(url).then((res) => res.data),

  apiUpload: (url, obj) =>
    axiosInstance
      .post(url, obj, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),
  apiPostExtrairExcel: (url, obj, nomeArquivo) =>
    axiosInstance
      .post(url, obj, {
        headers: { "Content-Type": "application/json" },
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = `${nomeArquivo}${
          res.headers["content-type"].includes("ms-excel") ? ".xls" : ".xlsx"
        }`;
        document.body.appendChild(link);
        link.click();
      }),
  apiGetExtrairExcel: (url, nomeArquivo) =>
    axiosInstance
      .get(url, {
        headers: { "Content-Type": "application/json" },
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = `${nomeArquivo}${
          res.headers["content-type"].includes("ms-excel") ? ".xls" : ".xlsx"
        }`;
        document.body.appendChild(link);
        link.click();
      }),
};

export default ApiServicesLogin;
